'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './home.routes';

export class HomeComponent {

  constructor($state, dialogs, $uibModal, Auth, PropertyService, WorkOrderTicketsService, ViolationTicketsService,
              $scope, ViewSelection, TaskService, HistoryService, ServiceRequestTicketsService, DTOptionsBuilder,
              ProjectItemService, DTState, SettingsService) {
    'ngInject';

    this.$state = $state;
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.Auth = Auth;
    this.TaskService = TaskService;
    this.tasks = [];
    this.items = [];
    this.activities = [];
    this.selectedCommunity = "";

    SettingsService.getByName({name: 'config.app'}, settings => {
      this.hideKPIs = settings.data.hide && settings.data.hide.dashboardKPIs;
    })

    this.dtOptionsWorkItems = DTOptionsBuilder.newOptions()
      //.withOption('dom', 'lBfrtip')
      .withOption('order', [0, 'asc'])
      .withOption('stateSave',true)
      .withOption('stateSaveCallback', DTState.save('WorkItems'))
      .withOption('stateLoadCallback', DTState.restore('WorkItems'))
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);

    this.dtOptionsActivities = DTOptionsBuilder.newOptions()
      //.withOption('dom', 'lBfrtip')
      .withOption('order', [0, 'desc'])
      .withOption('stateSave',true)
      .withOption('stateSaveCallback', DTState.save('Activities'))
      .withOption('stateLoadCallback', DTState.restore('Activities'))
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);

    Auth.getCurrentUser(user => {
      this.userId = user._id;
      //this.dtOptionsActivities = DTOptionsBuilder.newOptions().withOption('order', [[0, 'desc']])

      this.filteredData = {
        properties: [],
        workOrders: [],
        serviceRequests: [],
        violations: []
      };

      this.data = {
        properties: [],
        workOrders: [],
        serviceRequests: [],
        violations: []
      };

      this.count = {
        properties: 0,
        workOrders: 0,
        serviceRequests: 0,
        violations: 0
      };

      let fetchCount = 0;
      let maxFetchCount = 6;

      let updateSelected = (val) => {

        if (!val) {
          // global / all entities
          this.filteredData.properties = this.data.properties;
          this.filteredData.workOrders = this.data.workOrders;
          this.filteredData.violations = this.data.violations;
          this.filteredData.serviceRequests = this.data.serviceRequests;
        } else {
          this.filteredData.properties = this.data.properties.filter(prop => prop.community.code == val);
          this.filteredData.violations = this.data.violations.filter(ccr => ccr.property && ccr.property.community && ccr.property.community.code == val);
          this.filteredData.workOrders = this.data.workOrders.filter(wo =>
            (wo.community && wo.community.code == val)
            ||  (wo.property && wo.property.community && wo.property.community.code == val)
          );
          this.filteredData.serviceRequests = this.data.serviceRequests.filter(sr =>
            (sr.requester && sr.requester.communityCode == val)
            ||  (sr.property && sr.property.community && sr.property.community.code == val)
          );
        }

        this.count.properties = this.filteredData.properties.length;
        this.count.workOrders = this.filteredData.workOrders.length;
        this.count.serviceRequests = this.filteredData.serviceRequests.length;
        this.count.violations = this.filteredData.violations.length;
      };

      let next = () => {
        fetchCount++;
        if (fetchCount == maxFetchCount) {
          updateSelected(ViewSelection.selectedCommunityCode);
          let myWo = this.data.workOrders
            .filter(wo => wo.approvedBy && wo.approvedBy._id == this.userId)
            .map(item => {
              return {
                _id: item._id,
                priority: 0,
                dueDate: item.targetDate,
                type: 'workOrder',
                subject: `<a href="/workorder/ticket/detail/${item._id}">${item.code}: ${item.name}</a>`
              }
            });
          let myPi = this.data.projectItems
            .filter(pi => pi.assignedTo == this.userId)
            .map(item => {
              return {
                _id: item._id,
                priority: 0,
                dueDate: item.dueDate,
                type: 'projectItem',
                subject: item.title
              }
            });
          let myTask = this.data.tasks
            .filter(task => task.assignedTo && task.assignedTo._id == this.userId)
            .map(item => {
              return {
                _id: item._id,
                priority: item.priority,
                dueDate: item.dueDate,
                type: 'task',
                subject: item.subject,
                data: item
              }
            });

          this.items = [].concat(myWo, myPi, myTask);
          this.dataInitComplete = true;
        }
      };

      PropertyService.query(data => {
        this.data.properties = data;
        next();
      });
      WorkOrderTicketsService.query(data => {
        this.data.workOrders = data.filter(wo => wo.status == 'open');

        next();
      });
      ServiceRequestTicketsService.query(data => {
        this.data.serviceRequests = data.filter(wo => wo.status == 'open');
        next();
      });
      ViolationTicketsService.query(data => {
        this.data.violations = data.filter(wo => wo.status == 'open');
        next();
      });

      ProjectItemService.query(data => {
        this.data.projectItems = data;

        next();
      });

      TaskService.query(data => {
        this.data.tasks = data;

        next();
      });

      HistoryService.queryRecentActivities(data => this.activities = data);

      $scope.ViewSelection = ViewSelection;
      $scope.$watch('ViewSelection.selectedCommunity', (newVal, oldVal, scope) => {
        this.selectedCommunity = newVal.name;

        updateSelected(newVal.value);
      });
    })
  }

  createTask() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'taskEdit',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (task) {
        //TODO: reload tasks ??
        that.tasks.push(task);
      },
      function () { /* cancel */ }
    );

  }

  editTask(task) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'taskEdit',
      resolve: {
        config: function() {
          return {
            data: task
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (task) {
        that.TaskService.query(data => that.tasks = data);
      },
      function () { /* cancel */ }
    );

  }

  deleteTask(task) {
    var dlg = this.dialogs.confirm("Delete Task?", "Do you really want to delete this task?<br/><br/>" + task.subject);
    dlg.result.then(() => {
      this.TaskService.delete({id: task._id}, _ => {
        this.TaskService.query(data => this.tasks = data);
      });
    });
  }

  showTask(task) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'taskShow',
      resolve: {
        config: function() {
          return {
            data: task
          }
        }
      },
      size: 'md'
    });
  }

}

export default angular.module('conduu.home', [uiRouter])
  .config(routes)
  .component('home', {
    template: require('./home.html'),
    controller: HomeComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/home/home.component.js